import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const Timer = ({time}) => {
    const currentTime = moment(time).fromNow();
    return (<time dateTime={time}>{currentTime}</time>);
};

Timer.propTypes = {
    time: PropTypes.string.isRequired,
};

export default Timer;



// WEBPACK FOOTER //
// ./src/components/Timer.js